// extracted by mini-css-extract-plugin
module.exports = {"Background":"SiteBackground_Background__2YAAW"};